import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV2 } from './api';

export interface IUploadCloudsImageResponse {
  consultationId: string;
  userName: string;
  fileName: string;
  etag: string;
}

export interface IGetCloudsImagePresignedResponse {
  consultationId: string;
  userName: string;
  fileName: string;
  url: string;
}

export const cloudsApi = createApi({
  reducerPath: 'cloudsApi',
  baseQuery: baseQueryV2,
  tagTypes: ['CloudsImage'],
  endpoints: (build) => ({
    uploadCloudsImage: build.mutation<IUploadCloudsImageResponse, { consultationId: string; filename: string; file: Blob }>({
      query: ({ consultationId, filename, file }) => {
        const formData = new FormData();
        formData.append('file', file, filename);

        return {
          url: `/consultation-service/${consultationId}/clouds/image/${filename}`,
          method: 'POST',
          body: formData,
          formData: true,
        };
      },
      invalidatesTags: ['CloudsImage'],
    }),
    getCloudsImagePresigned: build.query<IGetCloudsImagePresignedResponse, { consultationId: string; filename: string }>({
      query: ({ consultationId, filename }) => ({
        url: `/consultation-service/${consultationId}/clouds/image/${filename}/presigned`,
      }),
      providesTags: ['CloudsImage'],
    }),
  }),
});

export const { useUploadCloudsImageMutation, useGetCloudsImagePresignedQuery } = cloudsApi;
